import { render, staticRenderFns } from "./TabellaMezzi.vue?vue&type=template&id=4a08bbd6&scoped=true&"
import script from "./TabellaMezzi.vue?vue&type=script&lang=js&"
export * from "./TabellaMezzi.vue?vue&type=script&lang=js&"
import style0 from "./TabellaMezzi.vue?vue&type=style&index=0&id=4a08bbd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08bbd6",
  null
  
)

export default component.exports